module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "الفصل-الأول"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "الإتيكيت-والأخلاق"
    }
  }, [_c('h2', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("(الإتيكيت) والأخلاق")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.65625in",
      "height": "2.63542in"
    },
    attrs: {
      "alt": "",
      "src": "media/file6.png"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تُعدُّ الأخلاقُ والآدابُ من أهمِّ المفاتيحِ لفتحِ عالمٍ من الفُرَصِ وتكوين علاقاتٍ ذاتِ معنًى، إنَّها ليست مجرَّدَ مجموعةٍ من القواعدِ الَّتي يجبُ اتِّباعُها بشكلٍ أعمى، ولكنَّها أسلوبُ حياةٍ يمكنُه تغييرُ طريقةِ تفاعُلنا مع العالم، وتمتلِكُ النِّساءُ القوَّةَ لإحداث تغييرٍ إيجابيٍّ في المجتمع من خلال أبسطِ تفاعُلٍ مع العالم من حولهنَّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("من خلال تبنِّي الآدابِ والأخلاق الحميدةِ، يمكنُنا التَّحكُّم في تفاعُلاتنا، وإحداثُ تأثيرٍ إيجابيٍّ في مَن حولنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("من خلالِ الأخلاق والعادات الحميدةِ، نُظهِرُ الاحترامَ لأنفسنا وللآخرين، ويبدأ الأمرُ بالاعتراف بقيمتِنا الشَّخصيَّةِ، ووضعِ معاييرَ عاليةٍ لأنفسِنا، بعد ذلك، يجبُ أنْ نتعلَّمَ كيفيَّةَ مراعاةِ أفكارِنا ومشاعِرنا، واحترامِ حدودِنا، بمجرَّدِ أنْ نَتَمكَّنَ من القيام بذلك لأنفُسِنا، يمكننا أنْ نُقدِّمَ نفسَ اللُّطف والمراعاةِ للنَّاس حولنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخيرًا، يساعِدُنا (الإتيكيت) في التَّغلُبِ على تعقيداتِ التَّفاعلات الاجتماعيَّةِ، ويُعزِّزُ اللُّطف والتَّواضعَ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تساعدنا الآدابُ والأخلاقُ الحميدةُ أيضًا في بناء الثِّقةِ، وخلقِ انطباعٍ أوَّلَ إيجابيٍّ، و(الإتيكيت) ضروريٌّ للحفاظ على العلاقات الإيجابيَّةِ، كما يُمكِّننا من تحسينِ صورَتِنا العامَّة، والأهمُّ من ذلك، يُعدُّ اعتناقُ الآدابِ والأخلاقِ رحلةً مُستمرَّةً لتحسين النَّفس، والتَّمكين الذَّاتيِّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كونُكِ سيِّدةً ذاتَ أخلاقٍ حَسَنَةٍ هو تجسيدٌ للثِّقةِ، والجمال، والرَّصانةِ، ويبدأُ الأمرُ بالاحترام، والطِّيبةِ، واللُّطفِ مع الآخرين، ومراعاةِ مشاعِرهِم، وإلهامِ النِّساءِ الأُخريات لمجاراةِ أسلوبِ حياتِكِ، ويتعلَّقُ الأمرُ أيضًا بكونِكِ امرأةً ذكيَّةً ومُثقَّفةً، ومُستمِعةً جيِّدةً عند محادثةِ الآخرين، وكونُكِ سيِّدةً ذاتَ أخلاقٍ حَسَنَة يعني البحثَ عن الحقيقةِ وعدمِ تصديقِ كُلِّ ما نَسمعُه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("باختصارٍ، يجبُ أنْ تُطلقِي العِنان لجوهرِك ليُشِعَّ على العالَم من حولكِ، وأنْ تَتَحلِّي بالامتنان بينما تُحافِظين دائمًا على قِلبِكِ وأفكاركِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا تَكمُن أهمِّيَّتُك كامرأةٍ في وظيفتِك أو وضعِكِ الاجتماعيِّ أو الاقتصاديِّ، لدينا جميعًا الحقُّ في تَعلُّمِ آدابِ السُّلوك أو فنِّ (الإتيكيت)، واتّباعِ الأخلاقِ الحميدةِ، وهذا لا يعني إطلاقًا أنْ نَتظاهرَ بما ليس فينا، بل يَتعلَّقُ الأمرُ بتنميةِ طريقةٍ أصيلةٍ ومُحتَرَمةٍ للتَّفاعلِ مع العالم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تعكِسُ أخلاقُنا هويَّتنا، وتُعطي انطباعًا عن شخصيَّتِنا وقِيَمِنا، إنَّها أدواتٌ قويَّةٌ يمكنُ أنْ تُساعدنا في التَّغلُّب على تعقيدات التَّفاعلات الاجتماعيَّةِ، والتَّأثيرِ بشكلٍ إيجابيٍّ في العالمِ مِن حولِنا، وإنَّ تبنِّيَ الآدابِ والأخلاقِ الحميدةِ يُمكِنُ أن يَجلِبَ لنا الشُّعورَ بالتَّمكين وتحقيق الذَّاتِ، ويُلهِمَ الآخرين لاتِّباع نفسِ الطَّريق.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دعونا نبدأ معًا في هذه الرِّحلةِ لتحسين الذَّات، والتَّمكينِ، وخلقِ عالمٍ أفضل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وبينما نتعمَّقُ في عالم الآدابِ والأخلاقِ، من الضَّروريِّ جدًّا فهم الاختلافات بين الاثنين، بِرغمِ وجود ترابُطٍ كبيرٍ بينهما، تُركِّزُ الأخلاقُ بشكلٍ أكبر على التَّفاصيلِ السُّلوكيَّةِ الَّتي تّكشِفُ عن شخصيّاتِنا وهويَّاتنا، ويمكنُ لأخلاقِكِ أنْ تُخبِرَنا كثيرًا عن هويَّتِكِ، وتَسمحَ لنا أنْ نُخمِّنَ مستَواكِ التَّعليميَّ، أو وضعَكِ الاجتماعِيَّ والاقتصاديَّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بينما نستكشِفُ عالمَ الأخلاقِ، من الضَّروريِّ أنْ نتذكَّرَ أنَّ كلَّ امرأةٍ لديها القُدرةُ على أنْ تكونَ كما تريدُ، ولهذا، لا تُقلِّلي من شأنِك أبدًا، سيِّدَتي، واسمحي لنفسِكِ بأنْ تحلمِي وتَطمَحِي للأحسن؛ لأنَّ أخلاقَكِ تعكِسُ هويَّتَكِ، ومثلما قالت الكاتبةُ (ج.ك. رولينغ): \"إنَّ اختياراتِنا هي الَّتي تُظهرُ من نحنُ حقًّا، أكثرَ بكثيرٍ من قُدراتِنا\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("والآن، دعونا نتحدَّثُ عن العادات، يبدأُ تحسينُ أخلاقِك وآدابكِ بتطوير عاداتٍ جيِّدةٍ من خلال جهدٍ متواصلٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إنَّ تطويرَ عاداتٍ جيِّدةٍ هو الخطوةُ الأولى نحوَ صقلِ أخلاقِك، لكنْ هذا الأمرُ لا يمكنُ أنْ يحدُثَ بين يومٍ وليلةٍ، يبدأُ الأمرُ من أبسطِ الأمورِ، مثلَ الطَّهارةِ والنَّظافةِ الشَّخصيَّةِ، حيثُ إنَّ الاعتناءَ بنفسكِ لا يتعلَّقُ بالتَّباهي، بل بتجسيدِ صفةٍ من الرَّصانة والاتّزان، إنَّهُ لأمرٌ طبيعيٌّ أنْ تكوني دائِمًا نظيفًة، وأنيقًة، وحسنةَ المَظهَرِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تُعدُّ ممارسةُ الرِّياضةِ أيضًا عادةً أساسيَّةً للحفاظِ على لياقَتِكِ وصِحَّتِكِ، وهو ما يُعدُّ عنصرًا أساسيًّا من الرِّعاية الذَّاتيَّةِ، هذا لا يعني إطلاقًا الانطلاقَ في جولةٍ لبناءِ الأجسامِ، يُمكِنُ أنْ تُساعِدَكِ التَّمارينُ البَسيطةُ مثلُ الجري في الحفاظِ على صِحَّتكِ ولياقَتِكِ البَدنِيَّةِ، ويُمكِنُكِ أيضًا دمجُ (اليوجا) في نمط حياتكِ؛ لأنَّها تُعدُّ تمرينًا أسهلَ بالنِّسبةِ للبعض، والهدفُ هو تطويرُ عادة رياضيَّة تُناسِبُ جِسمَكِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخيرًا، يُعدُّ فنُّ المحادثةِ عادةً مُهمَّةً أخرى سنستكشِفُها بمزيدٍ من التَّفصيلِ لاحقًا، ففنُّ التَّواصلِ والاستماعِ بانتباهٍ هو جزءٌ لا يتجزَّأُ من الأخلاقِ ومعاييرِ آداب السُّلوك، وإنَّ تطويرَ عاداتٍ جيِّدةٍ، مثل الانتباهِ إلى الشَّخص الَّذي تتحدَّثين معه، يمنحُه إحساسًا بالأهمِّيَّةِ وبقيمة الذَّات، من الضَّروريِّ أن نتعلَّمَ كيفيَّة التَّعبيرِ عن أنفُسِنا بهدوءٍ، حيثُ لا داعيَ للُّجوء إلى الصُّراخ أو الصَّوتِ العالي لتوصيل أفكارِنا، ويمكنُنا أنْ نُعبِّرَ عن أفكارِنا بسهولةٍ وبشكلٍ فعَّالٍ بصوتٍ هادِئٍ، وبلُطفٍ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.2915in",
      "height": "3.97403in"
    },
    attrs: {
      "alt": "",
      "src": "media/file7.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25a687bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0003.vue
// module id = 84
// module chunks = 0